import { VStack } from '@/package';

import { Container } from '../Container';
import { APIKeyList } from './APIKeyList';
import { APIKeyListPageOverview } from './APIKeyListPageOverview';

export const APIKeyListPageContainer = () => {
  return (
    <Container>
      <Container.Header>
        <APIKeyListPageOverview />
      </Container.Header>
      <Container.Content>
        <VStack className="h-full">
          <APIKeyList />
        </VStack>
      </Container.Content>
    </Container>
  );
};

APIKeyListPageContainer.displayName = 'APIKeyListPageContainer';
